<template>
    <AffiliationPanel
        @reloadRelations="$emit('reloadRelations')"
        @removeItem="removeItem"
        :name="isMe ? $lang.get('My memberships') : $lang.get('Groups')"
        :parentModel="parentModel"
        :items="groups"
        :recievedRequests="recievedRequests"
        :openModalButtonText="
            canEdit ? $lang.get('Handle memberships') : $lang.get('Show all')
        "
        :definitiveItemName="$lang.get('the membership')"
        :modalTitle="
            canEdit ? $lang.get('Handle memberships') : $lang.get('Groups')
        "
        :noApprovedItemsMsg="
            isMe ? $lang.get('No memberships') : $lang.get('No groups')
        "
        :removeButtonText="$lang.get('Leave group')"
        :canEdit="canEdit"
        :invitesEnabled="false"
        :onlyConfirmed="true"
    />
</template>

<script>
import AffiliationPanel from '@/Components/Panels/AffiliationPanel/AffiliationPanel.vue'

export default {
    name: 'MembershipsPanel',

    components: {
        AffiliationPanel,
    },

    emits: ['reloadRelations'],

    props: {
        parentModel: {
            type: Object,
            required: true,
        },
        items: {
            type: Array,
            default: [],
        },
        recievedRequests: {
            type: Array,
            default: [],
        },
        canEdit: {
            type: Boolean,
            default: false,
        },
        openOnLoad: {
            type: Boolean,
            default: false,
        },
        activeTab: {
            type: String,
            default: null,
        },
    },

    computed: {
        isMe() {
            return this.parentModel.id === this.$page.props.auth?.user?.id
        },

        groups() {
            return this.items.map((item) => {
                return {
                    ...item,
                    url: this.$getModelUrl({
                        modelClass: 'organization',
                        id: item.id,
                    }),
                }
            })
        },
    },

    methods: {
        removeItem(item_id) {
            axios
                .delete(route('api.affiliations.destroy', item_id))
                .then((response) => {
                    this.$emit('reloadRelations')
                })
        },
    },
}
</script>
